import { CreateChatMessageValidation } from 'types/chat.types';
import pluralize from 'pluralize';

export const getNearLimitMessage = (
  input: string,
  validation: CreateChatMessageValidation
) => {
  const { maxLength } = validation.properties.text;
  const remaining = maxLength - input.length;

  if (remaining < 0) {
    return '';
  }

  if (remaining <= 20) {
    return `${remaining} ${pluralize('character', remaining)} remaining`;
  }

  return '';
};
